import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSyncFailed = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m17.7216 17.4984h-15.4442c-.29771 0-.57281-.1589-.72167-.4167-.14885-.2578-.14885-.5755.00001-.8333l7.72166-13.33335c.14898-.2574.42384-.4159.72125-.4159.29745 0 .57225.1585.72125.4159l7.7217 13.33335c.1488.2577.1488.5752.0002.833-.1487.2577-.4235.4167-.7211.417zm-8.55503-4.1667v1.6667h.7775.05417.05416.7792v-1.6667zm0-5.83331v4.16671h1.66663v-4.16671z",
		fill: "#f2b14f"
	})
});
export { SvgSyncFailed as ReactComponent };
